import { useRef } from 'react'
import uniqueId from 'lodash/uniqueId'

export default prefix => useRef(uniqueId(prefix)).current
